// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"702a2975","108":"f97d4634","435":"f13d9846","488":"a310bbca","538":"ad0ed17a"}[chunkId] + ".chunk.js";
};